import React from 'react';
import { Box, VStack } from 'native-base';

import { Text } from '@pimm/base';

const displayValue = (value: unknown): string => {
  if (value === null || value === undefined) return '—';
  const textValue = String(value).trim();
  return textValue === '' ? '—' : textValue;
};

export const ReadOnlyField = ({ label, value, muted = false }: { label: string; value?: unknown; muted?: boolean }) => {
  const display = displayValue(value);
  return (
    <VStack space={0.5}>
      <Text size="md" fontWeight={500} color="gray.600">
        {label}
      </Text>
      <Text size="md" fontWeight={500} color={muted ? 'gray.400' : 'gray.900'} numberOfLines={1} accessibilityLabel={display}>
        {display}
      </Text>
    </VStack>
  );
};
